import React from "react";
import "./ChantTimePicker.css";
import { TimePicker } from "antd";
import { Controller } from "react-hook-form";

const ChantTimePicker = ({
  label,
  helpText,
  control,
  name,
  required,
  rules,
  disabled,
  value,
  defaultValue,
  onChange: customOnChange,
  ...props
}) => {
  const handleChange = (time, timeString) => {
    if (customOnChange) {
      customOnChange(time, timeString);
    }
  };

  // If control and name are provided, use Controller pattern
  if (control && name) {
    return (
      <div className="chant-timepicker-container">
        {label && (
          <label className="chant-timepicker-label">
            {label} {required ? <span style={{ color: "red" }}>*</span> : null}
          </label>
        )}
        <div className="chant-timepicker-wrapper">
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
              <div>
                <TimePicker
                  {...field}
                  {...props}
                  status={error ? "error" : ""}
                  disabled={disabled}
                  onChange={(time, timeString) => {
                    field.onChange(time);
                    if (customOnChange) {
                      customOnChange(time, timeString);
                    }
                  }}
                />
                {error && (
                  <div className="chant-timepicker-error">{error.message}</div>
                )}
              </div>
            )}
          />
        </div>
        {helpText && <div className="chant-timepicker-help">{helpText}</div>}
      </div>
    );
  }

  return (
    <div className="chant-timepicker-container">
      {label && (
        <label className="chant-timepicker-label">
          {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </label>
      )}
      <div className="chant-timepicker-wrapper">
        <TimePicker
          {...props}
          disabled={disabled}
          value={value}
          defaultValue={defaultValue}
          onChange={handleChange}
        />
      </div>
      {helpText && <div className="chant-timepicker-help">{helpText}</div>}
    </div>
  );
};

export default ChantTimePicker;
